import { render, staticRenderFns } from "./AsideConfigComponent.vue?vue&type=template&id=20a35460"
import script from "./AsideConfigComponent.vue?vue&type=script&lang=js"
export * from "./AsideConfigComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports